<form id="myForm" (ngSubmit)="onSubmit()" [formGroup]="form">
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="flex-column">
        <div class="flex-row gap-16">
          <!-- Left col avatar -->
          <div class="avatar-container banner" (click)="fileInputBanner.click()">
            <input class="hidden" #fileInputBanner type="file" accept="image/*" (change)="onBannerImageSelected($event)">
            <div class="icon-container" matTooltip="Upload banner">
              <mat-icon color="primary">photo_camera</mat-icon>
            </div>
            <div class="banner">
              <lib-photo [url]="photoBannerUrl" [width]="'195px'" [height]="'130px'" [radius]="'10px'"></lib-photo>
            </div>
            @if (!photoBannerUrl && !uploadBannerKey) {
              <div class="image-info">Banner 3:2</div>
            }
          </div>

          <div class="avatar-container thumb" (click)="fileInputAvatar.click()">
            <input class="hidden" #fileInputAvatar type="file" accept=".png, .jpg, .jpeg"
              (change)="onThumbImageSelected($event)">
            <div class="icon-container">
              <mat-icon color="primary">photo_camera</mat-icon>
            </div>
            <div class="avatar">
              <lib-photo [url]="photoUrl" [width]="'231.11px'" [height]="'130px'" [radius]="'10px'"></lib-photo>
            </div>
            @if (!photoUrl && !uploadPhotoKey) {
            <div class="image-info">Thumb 16:9</div>
            }
          </div>
        </div>
        <mat-form-field>
          <mat-label>Campaign Display Name</mat-label>
          <input type="text" required matInput placeholder="" formControlName="title" maxlength="50" autocomplete="off">
          @if (!form.get('title').valid) {
            <mat-error>Please enter a valid title</mat-error>
          }
        <mat-hint>Shown to consumers in the app.</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input matInput placeholder="" formControlName="description" maxlength="100" autocomplete="off">
          @if (!form.get('description').valid) {
            <mat-error>Please enter a valid description</mat-error>
          }
        </mat-form-field>
        <div class="description-wrapper" [class.fullscreen]="unjoinedDescriptionZoomed">
          @if (unjoinedDescriptionZoomed) {
            <button mat-icon-button class="close-button" (click)="unjoinedDescriptionZoomed = false">
              <mat-icon aria-hidden="false" aria-label="fullscreen mode" [fontIcon]="'close'"></mat-icon>
            </button>
          }
          <div class="description-header flex-row">
            <div class="description-title">
              <mat-label class="detailLabel">Detailed unjoined description</mat-label>
            </div>
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="end"
              [(selectedIndex)]="unjoinedDescriptionSelectedType" class="flex-1">
              <mat-tab label="Visual">
              </mat-tab>
              <mat-tab label="Text">
              </mat-tab>
            </mat-tab-group>
          </div>
          <div class="description-inner">
            @if (!unjoinedDescriptionZoomed) {
              <button mat-icon-button class="fullscreen-btn" (click)="unjoinedDescriptionZoomed = true">
                <mat-icon aria-hidden="false" aria-label="fullscreen mode"
                  [fontIcon]="!unjoinedDescriptionZoomed ? 'zoom_out_map': 'close'"></mat-icon>
              </button>
            }
            @if (unjoinedDescriptionSelectedType == 0) {
              <quill-editor (onEditorCreated)="getEditorInstance($event)" trackChanges="all"
                formControlName="detailedDescription" format="html" theme="snow" [modules]="modules" [sanitize]="false"></quill-editor>
            }
            @if (unjoinedDescriptionSelectedType == 1) {
              <ngx-monaco-editor
                formControlName="detailedDescription"
                [options]="monacoEditorOptions"
                (onInit)="onMonacoInit($event, 'detailedDescription')"
                class="monaco-editor-container">
              </ngx-monaco-editor>
            }
          </div>
        </div>
        <!-- JOINED Desc-->
        <div class="description-wrapper" [class.fullscreen]="joinedDescriptionZoomed">
          @if (joinedDescriptionZoomed) {
            <button mat-icon-button class="close-button" (click)="joinedDescriptionZoomed = false">
              <mat-icon aria-hidden="false" aria-label="fullscreen mode" [fontIcon]="'close'"></mat-icon>
            </button>
          }
          <div class="description-header flex-row">
            <div class="description-title">
              <mat-label class="detailLabel">Detailed joined description</mat-label>
            </div>
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="end" [(selectedIndex)]="joinedDescriptionSelectedType"
              class="flex-1">
              <mat-tab label="Visual">
              </mat-tab>
              <mat-tab label="Text">
              </mat-tab>
            </mat-tab-group>
          </div>
          <div class="description-inner">
            @if (!joinedDescriptionZoomed) {
              <button mat-icon-button class="fullscreen-btn" (click)="joinedDescriptionZoomed = true">
                <mat-icon aria-hidden="false" aria-label="fullscreen mode" [fontIcon]="'zoom_out_map'"></mat-icon>
              </button>
            }
            @if (joinedDescriptionSelectedType == 0) {
              <quill-editor (onEditorCreated)="getEditorInstance($event)" trackChanges="all"
                formControlName="detailedDescriptionJoined" format="html" theme="snow" [modules]="modules" [sanitize]="false"></quill-editor>
            }
            @if (joinedDescriptionSelectedType == 1) {
              <ngx-monaco-editor
                formControlName="detailedDescriptionJoined"
                [options]="monacoEditorOptions"
                (onInit)="onMonacoInit($event, 'detailedDescriptionJoined')"
                class="monaco-editor-container">
              </ngx-monaco-editor>
            }
          </div>
        </div>

        @if (isHandshakeQR) {
          <div class="description-wrapper" [class.fullscreen]="joinedDescriptionZoomed">
            @if (joinedDescriptionZoomed) {
              <button mat-icon-button class="close-button" (click)="joinedDescriptionZoomed = false">
                <mat-icon aria-hidden="false" aria-label="fullscreen mode" [fontIcon]="'close'"></mat-icon>
              </button>
            }
            <div fxLayout="row" class="description-header">
              <div class="description-title">
                <mat-label class="detailLabel">Detailed joined description for retailer</mat-label>
              </div>
              <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                [(selectedIndex)]="joinedDescriptionSelectedType">
                <mat-tab label="Visual">
                </mat-tab>
                <mat-tab label="Text">
                </mat-tab>
              </mat-tab-group>
            </div>
            <div class="description-inner">
              @if (!joinedDescriptionZoomed) {
                <button mat-icon-button class="fullscreen-btn" (click)="joinedDescriptionZoomed = true">
                  <mat-icon aria-hidden="false" aria-label="fullscreen mode" [fontIcon]="'zoom_out_map'"></mat-icon>
                </button>
              }
              @if (joinedDescriptionSelectedType == 0) {
                <quill-editor (onEditorCreated)="getEditorInstance($event)" trackChanges="all"
                  formControlName="detailedDescriptionJoinedForRetailer" format="html" theme="snow"
                  [modules]="modules" [sanitize]="false"></quill-editor>
              }
              @if (joinedDescriptionSelectedType == 1) {
                <ngx-monaco-editor
                  formControlName="detailedDescriptionJoinedForRetailer"
                  [options]="monacoEditorOptions"
                  (onInit)="onMonacoInit($event, 'detailedDescriptionJoinedForRetailer')"
                  class="monaco-editor-container">
                </ngx-monaco-editor>
              }
            </div>
          </div>
        }

        <mat-form-field>
          <mat-label>Onboarding landing page URL</mat-label>
          <input type="text" matInput placeholder="" formControlName="onboardingUrl" autocomplete="off">
          <button mat-icon-button matSuffix type="button" matTooltip="Create landing page in Content Management" (click)="openPageBuilder()">
            <mat-icon>construction</mat-icon>
          </button>
          @if (!form.get('onboardingUrl').valid) {
          <mat-error>Please enter a valid onboarding url</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Term and Conditions URL</mat-label>
          <input type="text" matInput placeholder="" formControlName="termAndConditions" autocomplete="off">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Privacy Policy URL</mat-label>
          <input type="text" matInput placeholder="" formControlName="privacyPolicy" autocomplete="off">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Allowed Country Codes (Phone OTP)</mat-label>
          <input matInput formControlName="allowedCountryCodes" placeholder="e.g. SG, PH, TH (leave empty to allow all)" autocomplete="off">
          <mat-hint>Comma-separated ISO 3166-1 alpha-2 codes. Leave empty to allow all countries.</mat-hint>
        </mat-form-field>

        @if (!form.value.isGlobal) {
        <app-multi-labels [isCountry]="true" searchKey="name" [labels]="filteredCountries"
          [availableLabelsQuery]="allCountries" [refreshAutocomplete]="refreshCountries" formControlName="countries" name="countries"
          [placeholder]="'Countries'"></app-multi-labels>
        }

        <app-multi-labels
          searchKey="name"
          [labels]="filteredLanguages"
          [availableLabelsQuery]="allLanguages"
          [refreshAutocomplete]="refreshLanguages"
          formControlName="languages"
          name="languages"
          [placeholder]="'Languages'"
          (changed)="onCampaignLanguagesChanged($event)">
        </app-multi-labels>

        @if (availableLanguagesForPrimary.length > 0) {
          <mat-form-field>
            <mat-label>Primary Language</mat-label>
            <mat-select formControlName="primaryLanguage">
              @for (lang of availableLanguagesForPrimary; track lang.code) {
                <mat-option [value]="lang.code">{{ lang.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <div class="flex-row gap-16">
          <mat-form-field class="flex-1">
            <mat-label>Start date</mat-label>
            <input matInput type="text" [matDatepicker]="startDate" placeholder="" formControlName="startDate"
              autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="flex-1">
            <mat-label>End date</mat-label>
            <input matInput type="text" [matDatepicker]="endDate" placeholder="" formControlName="endDate"
              autocomplete="off">
            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="flex-row gap-16">
          <mat-form-field class="flex-1">
            <mat-label>Time zone</mat-label>
            <mat-select formControlName="timeZoneInfoId">
              @for (s of timeZoneInfos$ | async; track s) {
              <mat-option [value]="s.id">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex-1">
            <mat-label>Status</mat-label>
            <mat-select required formControlName="campaignStatus">
              <mat-option value="0">-</mat-option>
              @for (s of campaignStatuses; track s) {
              <mat-option [value]="s.value">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-row gap-16">
          <div class="flex-column gap-16">
            <mat-slide-toggle formControlName="overAge" color="primary">
              <label class="form-label">Age Over </label>
              <input type="number" class="dynamic-age" formControlName="dynamicAge">
            </mat-slide-toggle>
            <mat-slide-toggle formControlName="shouldAdvertise" color="primary">
              <label class="form-label">Should Advertise</label>
            </mat-slide-toggle>
            <mat-slide-toggle formControlName="canJoin" color="primary">
              <label class="form-label">Can Join</label>
            </mat-slide-toggle>
            <mat-slide-toggle formControlName="blockRedemptionOnJoin" color="primary">
              <label class="form-label">Block redemption on join</label>
            </mat-slide-toggle>
            @if (isStaffCampaign) {
            <mat-slide-toggle formControlName="isForceUsingMobileApp" color="primary">
              <label class="form-label">Force using Mobile App</label>
            </mat-slide-toggle>
            }
            <mat-slide-toggle formControlName="shouldHideParticipatingLocations" color="primary">
              <label class="form-label">Hide participating locations</label>
            </mat-slide-toggle>
          </div>

          <div class="flex-column gap-16">
            @if (!isBrandAdmin) {
              <mat-slide-toggle formControlName="isGlobal" color="primary">
                <label class="form-label">Is Global</label>
              </mat-slide-toggle>

              @if (!isInformationStrategy) {
                <mat-slide-toggle formControlName="allowDuplicates" color="primary">
                  <label class="form-label">Allow duplicates</label>
                </mat-slide-toggle>

                <mat-slide-toggle formControlName="allowGiveStamps" color="primary">
                  <label class="form-label">Allow staff to give stamps</label>
                </mat-slide-toggle>
              }
              <mat-slide-toggle formControlName="synchronizationContactGLO" color="primary"
                (change)="isContactSyncChanged($event)">
                <label class="form-label">GLO Contact Synchronization</label>
              </mat-slide-toggle>
              <mat-slide-toggle formControlName="synchronizationDataConsumerGLO" color="primary"
                (change)="isDataConsumerSyncChanged($event)">
                <label class="form-label">Advertiser Data Sync</label>
              </mat-slide-toggle>
            }
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
